import Drawer from 'react-modern-drawer';
import React, { useEffect, useState } from "react";
import ReportsServices from './ReportsServices';
import { CommonUtilities } from 'commonUtils';
import ReportingInvoices from './ReportingInvoices';
import Reporting_transaction from './ReportingTransaction';
import DeleteDialogueBox from 'components/Common/deleteDialogue';

export default function ManualReference(param: any) {

    const [AddedTransactions, setAddedTransactions] = useState(false);
    const [ExistingReferences, setExistingReferences] = useState<any>([]);
    const [ReportingTransaction, setReportingTransaction] = useState(false);
    const [toggleBox, settoggleBox] = useState("");

    useEffect(() => {
        getExistingReferences()
    }, [param.ManualReferenceOpen]);

    const closeManualReference = () => {
        console.log("closeManualReference")
        var selection = ExistingReferences?.filter((e: any) => e.processReferenceId == toggleBox)[0]
        console.log(selection)
        param.closeManualReference(selection);
    }

    const getExistingReferences = () => {

        ReportsServices.ExistingReferences().then((res) => {
            console.log(res)

            console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            setExistingReferences(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
        });
    }

    const closeReportingInvoices = () => {
        setAddedTransactions(false)
    }

    const closeReportingTransaction = () => {
        setReportingTransaction(false)
    }

    let [deleteData, setDeleteData] = useState<any>([]);
    let [deleteStatus, setDeleteStatus] = useState(false);
    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        console.log(deleteData)
        if (e == 1) {
            ReportsServices.deleteReferences(deleteData)
        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }

    return (<>
        <Drawer open={param.ManualReferenceOpen} onClose={closeManualReference} direction='right' >

            <div className="box noBorderRadius noBorder full-height-vh pull-right ws-5">
                <div className="box-header-main">
                    <h2>Existing References</h2>
                </div>

                <div className="box-content pull-right">
                    <div className="form-format ws-12 mb">
                        <input type="text" placeholder="Filter" className='ws-6 height35' />
                        <button className="icon-btn edit caret lineHeight height35" onClick={getExistingReferences}><i className="icon-search"></i></button>
                        <button className="icon-btn edit caret lineHeight height35" onClick={() => setAddedTransactions(true)}>Add Reference </button>
                    </div>

                    <div className="ws-12 ">
                        <table className="newTable">
                            <thead>
                                <th></th>
                                <th>Week Number</th>
                                <th>Year Number</th>
                                <th>Manual References</th>
                                <th></th>
                            </thead>
                            {
                                ExistingReferences.map((post: any, index: any) => {
                                    return (
                                        <tbody>
                                            <tr>
                                                <td onClick={() => { settoggleBox(post.processReferenceId); setReportingTransaction(true) }}>
                                                    <input type="radio" name="radio1" value={post.processReferenceId} checked={toggleBox == post.processReferenceId} />
                                                </td>
                                                <td>{post.weekNumber}</td>
                                                <td>{post.yearNumber}</td>
                                                <td>{post.manualReference}</td>
                                                <td><button className="icon-btn delete" onClick={() => { setDeleteStatus(true); setDeleteData(post) }}><i className="icon-trashcan"></i></button></td>
                                            </tr>

                                        </tbody>
                                    )
                                })}


                        </table>

                    </div>

                    <div className="box-footer ws-12">
                        <button className="icon-btn delete pull-right height35 " onClick={closeManualReference}> Close </button>
                    </div>

                </div>


                {(() => {
                    if (AddedTransactions) {
                        return <ReportingInvoices ReportingInvoicesOpen={AddedTransactions} closeReportingInvoices={closeReportingInvoices} />
                    }

                    if (ReportingTransaction) {
                        return <Reporting_transaction ReportingTransactionOpen={ReportingTransaction} ExistingReferences={ExistingReferences} selectedReference={toggleBox} closeReportingTransaction={closeReportingTransaction} />
                    }

                    if (deleteStatus) {
                        return <DeleteDialogueBox param={deleteStatus} message={"to delete this reference"} onChange={deleteConfirmation} />
                    }
                })()}

            </div>

        </Drawer>
    </>)

}